<template>
  <div class="flex-s-s">
    <div>
      <div class="card mar16 calendar">
        <div class="calendar-current-date">
          <i class="el-icon-d-arrow-left mar16" @click="changeYear('pre')"></i>
          <i class="el-icon-arrow-left mar16" @click="changeMonth('pre')"></i>
          <span class="mar16"> {{currentDay.split('-')[0]}}年&nbsp;{{currentDay.split('-')[1]}}月</span>
          <i class="el-icon-arrow-right mar16" @click="changeMonth('next')"></i>
          <i class="el-icon-d-arrow-right" @click="changeYear('next')"></i>
        </div>
        <ul class="weekdays">
          <li>日</li>
          <li>一</li>
          <li>二</li>
          <li>三</li>
          <li>四</li>
          <li>五</li>
          <li>六</li>

        </ul>
        <ul class="days">
          <li v-for="(item,index) in dayList" :class="[item.month==currentDay.split('-')[1]?'':'other-days',eventDate.indexOf(item.text)!==-1?'has':'']" @click="dayClick(item)">
            <span :class="[nowYear+'-'+nowMonth+'-'+nowDay==item.text?'current-date':'',activeDay==item.text?'active-date':'']">{{item.day}}</span>
          </li>
          <!-- <li v-for="(item,index) in 42" :class="">
          <span class="">{{item}}</span>
        </li> -->
        </ul>
      </div>
      <div class="card mar16 mat10 flex-sb-c" style="min-height:60px">
        <span>就餐状态:
          <span v-if="mealStatus==0">未申请</span>
          <span v-if="mealStatus==1">已申请</span>
        </span>
        <span v-if=" Date.parse(activeDay)>=Date.parse(nowYear+'-'+nowMonth+'-'+nowDay)">
          <el-button type="primary" v-if="mealStatus==0" @click="meal('1')" :disabled="disabled">申请就餐</el-button>
          <el-button type="primary" v-if="mealStatus==1" @click="meal('0')" :disabled="disabled">取消就餐</el-button>
        </span>
      </div>
      <!-- <div class="card mar16 mat10 flex-sb-c">
        <span>就餐状态:已申请</span>
        <span>
          <el-button>取消</el-button>
        </span>
      </div> -->
    </div>
    <div class="card content">
      <i class="el-icon-arrow-left arrow left" @click="pre" v-if="itemIndex!==0"></i>
      <i class="el-icon-arrow-right arrow right" @click="next" v-if="itemIndex<activeListLen-1"></i>
      <div style="width:calc(100% - 100px);margin:auto">

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="讲解" name="explain" v-if="userMess.applyPost==1||userMess.applyPost==3">
            <template v-if="activeListLen==0">
              <div class="no-data">
                <img src="@images/none.png" />
                <div>暂无数据</div>
              </div>
            </template>
            <template v-else>
              <ul class="key-value" v-for="(item,index) in explainList" v-if="itemIndex==index">
                <li v-for="cItem in item.fieldList">
                  <div class="key">{{cItem.taskFieldKey}}</div>
                  <div class="value">{{cItem.taskFieldValue}}</div>
                </li>
              </ul>
            </template>
          </el-tab-pane>
          <el-tab-pane label="服务" name="service" v-if="userMess.applyPost==1||userMess.applyPost==3||userMess.applyPost==2">
            <template v-if="activeListLen==0">
              <div class="no-data">
                <img src="@images/none.png" />
                <div>暂无数据</div>
              </div>
            </template>
            <template v-else>
              <ul class="key-value" v-for="(item,index) in serviceList" v-if="itemIndex==index">
                <li v-for="cItem in item.fieldList">
                  <div class="key">{{cItem.taskFieldKey}}</div>
                  <div class="value">{{cItem.taskFieldValue}}</div>
                </li>
              </ul>
            </template>
          </el-tab-pane>
          <el-tab-pane label="策划" name="plan" v-if="userMess.applyPost==3">
            <template v-if="activeListLen==0">
              <div class="no-data">
                <img src="@images/none.png" />
                <div>暂无数据</div>
              </div>
            </template>
            <template v-else>
              <ul class="key-value" v-for="(item,index) in planList" v-if="itemIndex==index">
                <li v-for="cItem in item.fieldList">
                  <div class="key">{{cItem.taskFieldKey}}</div>
                  <div class="value">{{cItem.taskFieldValue}}</div>
                </li>
              </ul>
            </template>
          </el-tab-pane>
          <el-tab-pane label="其他活动" name="activity">
            <template v-if="activeListLen==0">
              <div class="no-data">
                <img src="@images/none.png" />
                <div>暂无数据</div>
              </div>
            </template>
            <template v-else>
              <ul class="key-value" v-for="(item,index) in activityList" v-if="itemIndex==index">

                <li v-for="cItem in item.fieldList">
                  <div class="key">{{cItem.taskFieldKey}}</div>
                  <div class="value">{{cItem.taskFieldValue}}</div>
                </li>
              </ul>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { getYearMonthDay, formatDate } from '@/libs/utils'
export default {
  components: {},
  data() {
    return {
      activeName: "explain",
      activeListLen: 0,
      messageList: [
        { key: "活动名称", value: "010-09-22 09:20:09" },
        { key: "活动编号", value: "23131233" },
        { key: "发布时间 ", value: "类型活动类型活动类型活动类型活动类型" },
        { key: "类型 ", value: "2020-10-12" },
        { key: "活动日期 ", value: "15：00" },
        { key: "活动时间", value: "12人" },
        { key: "招募人数", value: "2010-10-10" },
        { key: "活动说明", value: "12人" },
        { key: "报名时间", value: "2010-10-10" }
      ],
      tabsList: ["explain", "service", "plan", "activity"],
      explainList: [{}, {}, {}],
      serviceList: [{}, {}, {}],
      planList: [],
      activityList: [],
      itemIndex: 0,
      dayList: [],
      nowYear: new Date().getFullYear(),
      nowMonth: (new Date().getMonth() + 1).toString().padStart(2, "0"),
      nowDay: new Date().getDate().toString().padStart(2, "0"),
      activeDay: new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, "0") + '-' + new Date().getDate().toString().padStart(2, "0"),
      currentDay: new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, "0") + '-' + new Date().getDate().toString().padStart(2, "0"),
      eventDate: [],
      mealStatus: 0,
      userMess: this.$store.state.user.user,
      disabled: false
    };
  },
  computed: {},
  watch: {
    activeName() {
      let list = []
      if (this.activeName == 'explain') list = this.explainList
      else if (this.activeName == 'service') list = this.serviceList
      else if (this.activeName == 'plan') list = this.planList
      else if (this.activeName == 'activity') list = this.activityList

      this.activeListLen = list.length
    }
  },
  methods: {
    //获取有活动的日期
    getEvent(val) {
      let date = formatDate(val, 5)
      let params = {
        yearMonth: date,
        volunteerId: this.userMess.id
      }
      this.$api.getExistTaskDate(params).then(res => {
        this.eventDate = res.data
        // console.log(res.data)
      })
    },
    //上一条活动
    pre() {
      let list = []
      if (this.activeName == 'explain') list = this.explainList
      else if (this.activeName == 'service') list = this.serviceList
      else if (this.activeName == 'plan') list = this.planList
      else if (this.activeName == 'activity') list = this.activityList
      this.activeListLen = list.length
      if (this.itemIndex <= 0) this.itemIndex = 0
      else this.itemIndex -= 1
      // let index = this.tabsList.indexOf(this.activeName)
      // let len = this.tabsList.length
      // if (index <= 0) this.activeName = this.tabsList[len - 1]
      // else this.activeName = this.tabsList[index - 1]
    },
    //下一条活动
    next() {
      let list = []
      if (this.activeName == 'explain') list = this.explainList
      else if (this.activeName == 'service') list = this.serviceList
      else if (this.activeName == 'plan') list = this.planList
      else if (this.activeName == 'activity') list = this.activityList
      this.activeListLen = list.length
      if (this.itemIndex < list.length - 1) this.itemIndex += 1
      else this.itemIndex = list.length - 1
      // let index = this.tabsList.indexOf(this.activeName)
      // let len = this.tabsList.length
      // if (index >= len - 1) this.activeName = this.tabsList[0]
      // else this.activeName = this.tabsList[index + 1]
    },
    //申请、取消就餐
    meal(type) {
      let submit
      if (type == 0) submit = this.$api.mealCancel
      else if (type == 1) submit = this.$api.mealApply
      let params = {
        diningDate: this.activeDay,
        volunteerId: this.userMess.id
      }
      this.disabled = true
      submit(params).then(res => {
        // console.log(res)

        if (res.code == 1) {
          this.$message.success(res.message);
          this.getDateOfEvent(this.activeDay)
        } else {
          // console.log("sss")
          this.disabled = false
          this.$message.error(res.message);
        }
      })
    },
    handleClick() {
      this.itemIndex = 0
    },
    getDate(initdate) {
      let now = initdate ? new Date(initdate) : new Date();
      let year = now.getFullYear();
      let month = now.getMonth();
      let day = now.getDate();
      // console.log(day)
      // 当前月份的第一天
      let currentFirstDay = Date.parse(new Date(year, parseInt(month), 1));
      // 当前月份的第一天是周几
      // let date = year + "-" + month + "-01";
      let weekDay = getYearMonthDay(currentFirstDay).zhouN;
      // console.log(currentFirstDay)
      // 当月的第一天减去 周几前面几天 这样就能得到上个月开始的天数
      let startTime = currentFirstDay - (weekDay) * 24 * 60 * 60 * 1000;
      // let startTime = weekDay == 0 ? currentFirstDay - 6 * 24 * 60 * 60 * 1000 : currentFirstDay - (weekDay - 1) * 24 * 60 * 60 * 1000;
      this.dayList = [];
      for (let i = 0; i < 42; i++) {
        let year = new Date(startTime + i * 24 * 60 * 60 * 1000).getFullYear()
        let month = (new Date(startTime + i * 24 * 60 * 60 * 1000).getMonth() + 1).toString().padStart(2, "0")
        let day = new Date(startTime + i * 24 * 60 * 60 * 1000).getDate().toString().padStart(2, "0")
        this.dayList.push({
          // timestamp: Date.parse(new Date(startTime + i * 24 * 60 * 60 * 1000)),
          date: new Date(startTime + i * 24 * 60 * 60 * 1000),
          year: year,
          month: month,
          day: day,
          text: year + '-' + month + '-' + day
        });
      }
      // console.log(this.dayList)
    },
    dayClick(val) {
      this.itemIndex = 0
      this.activeDay = val.text
      this.getDateOfEvent(val.text)
    },
    //获取选中日期的活动
    getDateOfEvent(val) {
      let params = {
        chooseDate: val,
        volunteerId: this.userMess.id
      }
      this.$api.getTaskInfoByDate(params).then(res => {
        this.disabled = false
        let explain = []
        let service = []
        let plan = []
        let activity = []
        res.data.myTaskList.map(item => {
          if (item.activityType == 1) explain.push({ ...item })
          else if (item.activityType == 2) service.push({ ...item })
          else if (item.activityType == 3) plan.push({ ...item })
          else if (item.activityType == 4) activity.push({ ...item })
        })
        // console.log(res.data)

        this.explainList = explain
        this.serviceList = service
        this.planList = plan
        this.activityList = activity
        // mealStatus (integer, optional): 就餐状态 0未申请就餐 1已申请就餐 
        this.mealStatus = res.data.mealStatus
        let list = []
        if (this.activeName == 'explain') list = this.explainList
        else if (this.activeName == 'service') list = this.serviceList
        else if (this.activeName == 'plan') list = this.planList
        else if (this.activeName == 'activity') list = this.activityList

        this.activeListLen = list.length
        // console.log(this.activeListLen)
      })
    },
    changeMonth(type) {
      let year = parseInt(this.currentDay.split('-')[0])
      let month = parseInt(this.currentDay.split('-')[1])
      let day = this.currentDay.split('-')[2]
      if (type == 'pre') {
        this.currentDay = month == 1 ? (year - 1) + '-12-' + day : year + '-' + (month - 1).toString().padStart(2, "0") + '-' + day
        this.getDate(this.currentDay)
        this.getEvent(this.currentDay)
      } else {
        this.currentDay = month == 12 ? (year + 1) + '-01-' + day : year + '-' + (month + 1).toString().padStart(2, "0") + '-' + day
        this.getDate(this.currentDay)
        this.getEvent(this.currentDay)
      }
    },
    changeYear(type) {
      let year = parseInt(this.currentDay.split('-')[0])
      let month = this.currentDay.split('-')[1]
      let day = this.currentDay.split('-')[2]
      if (type == 'pre') {
        this.currentDay = (year - 1) + '-' + month + '-' + day
        this.getDate(this.currentDay)
        this.getEvent(this.currentDay)
      } else {
        this.currentDay = (year + 1) + '-' + month + '-' + day
        this.getDate(this.currentDay)
        this.getEvent(this.currentDay)
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDate("")
    this.getEvent("")
    this.getDateOfEvent(this.activeDay)
    //判断什么岗位，tag显示
    if (this.userMess.applyPost == 1 || this.userMess.applyPost == 3) {
      this.activeName = "explain"
      this.activeListLen = this.explainList.length
    }
    else if (this.userMess.applyPost == 2) {
      this.activeName = "service"
      this.activeListLen = this.serviceList.length
    }
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.calendar {
  width: 386px;
  padding: 20px 10px;
  &-current-date {
    text-align: center;
  }
}
.weekdays {
  margin-top: 30px;
  display: flex;
  li {
    width: 52px;
    padding: 10px 0 10px;
    text-align: center;
    font-weight: bold;
  }
}
.days {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  li {
    position: relative;
    width: 52px;
    height: 40px;
    margin: 0px 0;
    text-align: center;
    cursor: pointer;

    span {
      position: relative;
      display: inline-block;
      width: 30px;
      height: 30px;
      border-radius: 4px;
      line-height: 30px;
    }
    span:after {
      // content: "";
      position: absolute;
      bottom: 0;
      left: 12px;
      // display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: @bg-green;
    }
    span.active {
      background-color: @bg-green;
      color: #fff;
    }
  }
  li.other-days {
    color: #cccbce;
  }
  li.has:after {
    content: "";
    position: absolute;
    bottom: 2px;
    left: 24px;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: chocolate;
  }
  .current-date {
    background: #cccbce;
    color: #fff;
  }
  .active-date {
    background: @bg-green;
    color: #fff;
  }
}
.content {
  width: calc(100% - 402px);
  min-height: 300px;
  position: relative;
  .arrow {
    position: absolute;
    font-size: 40px;
    top: 160px;
    cursor: pointer;
  }
  .arrow.left {
    left: 0;
  }
  .arrow.right {
    right: 0;
  }
}
</style>
